export const IMAGE_EXTENSIONS = [
	'jpg',
	'jpeg',
	'png',
	'gif',
	'bmp',
	'webp',
	'svg',
	'heic',
];

export const VIDEO_EXTENSIONS = [
	'mp4',
	'avi',
	'mov',
	'wmv',
	'flv',
	'mkv',
	'webm',
];

export enum AttachmentSourceType {
	IMAGE = 'image',
	VIDEO = 'video',
	PDF = 'pdf',
	UNKNOWN = 'unknown',
}

export const HEIC_GROUP =
	'.heif,.heifs,.heic,.heics,image/heif,image/heif-sequence,image/heic,image/heic-sequence,image/avif';

// TODO: Adjust mime types to match which one does backend support
export enum AttachmentMimeType {
	JPEG = 'image/jpeg',
	GIF = 'image/gif',
	PNG = 'image/png',
	JPG = 'image/jpg',
	HEIC = HEIC_GROUP,

	MP4 = 'video/mp4',
	MPEG = 'video/mpeg',
	WEBM = 'video/webm',

	PDF = 'application/pdf',
}

export const IMAGE_MIME_TYPES = [
	AttachmentMimeType.JPEG,
	AttachmentMimeType.GIF,
	AttachmentMimeType.PNG,
	AttachmentMimeType.JPG,
	AttachmentMimeType.HEIC,
];

export const VIDEO_MIME_TYPES = [
	AttachmentMimeType.MP4,
	AttachmentMimeType.MPEG,
	AttachmentMimeType.WEBM,
];

export const PDF_MIME_TYPES = [AttachmentMimeType.PDF];

export const ALL_MIME_TYPES = [
	AttachmentMimeType.PDF,
	AttachmentMimeType.JPG,
	AttachmentMimeType.JPEG,
	AttachmentMimeType.PNG,
	AttachmentMimeType.HEIC,
];

export const MIN_FILE_SIZE_IN_MB = 0;
export const MAX_FILE_SIZE_IN_MB = 10;

// copy from react-dropzone-esm
export enum ErrorCode {
	FileInvalidType = 'file-invalid-type',
	FileTooLarge = 'file-too-large',
	FileTooSmall = 'file-too-small',
}
